var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"co pill mw-100",class:( _obj = {
        outline: _vm.outline,
        truncate: _vm.truncate
    }, _obj[_vm.variant] = true, _obj.iconleft = _vm.iconleft, _obj.iconright = _vm.iconright, _obj ),attrs:{"title":_vm.title || _vm.text}},[_c('div',{staticClass:"d-flex align-items-center w-100 h-100"},[(_vm.iconleft)?_c('CoIcon',{attrs:{"name":_vm.iconleft}}):_vm._e(),_c('span',{staticClass:"mw-0 flex-fill"},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2),(_vm.iconright)?_c('CoIcon',{attrs:{"name":_vm.iconright}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }